import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Card, Accordion, Row, Col } from "react-bootstrap";
import _ from "lodash";
import { useEffect, useState } from "react";
import { FormUIItem } from "../commons";
import { formatMoney } from "common/Utils";
import { styles } from "./styles";
import { setPayment, setUnPayment } from "../../domain/apis/contractService";

function ContractDetailComponent({ show, handleClose, data }) {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    var invoiceRet = (data?.services ?? []).map((o) => {
      return {
        serviceType: o.entityType == "vps" ? "VPS Hosting" : "Domain",
        code: `${o.entityType == "vps" ? "VPS Hosting" : "Domain"}`,
        total: o.price,
      };
    });
    setInvoices(invoiceRet);
  }, [data]);

  function handlePayment(id) {
    const choice = window.confirm("Xác nhận?");
    if (choice) {
      setPayment({ id }).subscribe({
        next({ data }) {
          if (data.status) {
            handleClose({ isReload: true });
          }
        },
      });
    }
  }

  function handleUnPayment(id) {
    const choice = window.confirm("Xác nhận?");
    if (choice) {
      setUnPayment({ id }).subscribe({
        next({ data }) {
          if (data.status) {
            handleClose({ isReload: true });
          }
        },
      });
    }
  }

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      //backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Modal.Title>{"HỢP ĐỒNG - DỊCH VỤ"}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="container py-4">
          {/* Thông tin hợp đồng */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Thông tin</h5>

            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <FormUIItem
                    readOnly
                    label={"Tên"}
                    code={"name"}
                    value={data?.name}
                  />
                </Col>
                <Col md={6}>
                  <FormUIItem
                    label={"Mã Hợp Đồng"}
                    code={"code"}
                    readOnly
                    value={data?.code}
                  />
                </Col>
              </Row>

              <FormUIItem
                label={"Giáo Phận"}
                code={"organizationName"}
                readOnly
                value={data?.organizationName}
              />
              <FormUIItem
                label={"Đại diện"}
                code={"customerName"}
                readOnly
                value={data?.customerName}
              />

              <FormUIItem
                label={"Mô tả"}
                code={"description"}
                readOnly
                value={data?.description}
              />
            </Form>
          </Card>

          {/* Dịch vụ đi kèm */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Dịch vụ</h5>
            <Form>
              {(data?.services?.length ?? 0) > 0 && (
                <Row className="mb-3">
                  <Col md={6}>
                    <FormUIItem
                      readOnly
                      label={"Dịch vụ VPS"}
                      code={"serviceName1"}
                      value={data?.services[0]?.name}
                    />
                  </Col>
                  <Col md={6}>
                    <FormUIItem
                      label={"Loại"}
                      code={"servicePackage1"}
                      readOnly
                      value={data?.services[0]?.packageName}
                    />
                  </Col>
                </Row>
              )}
              {(data?.services?.length ?? 0) > 1 && (
                <Row className="mb-3">
                  <Col md={6}>
                    <FormUIItem
                      readOnly
                      label={"Dịch vụ Domain"}
                      code={"serviceName2"}
                      value={data?.services[1]?.name}
                    />
                  </Col>
                  <Col md={6}>
                    <FormUIItem
                      label={"Loại"}
                      code={"servicePackage2"}
                      readOnly
                      value={data?.services[1]?.packageName}
                    />
                  </Col>
                </Row>
              )}
            </Form>
          </Card>

          {/* Hóa đơn liên quan */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Hóa đơn</h5>
            <Accordion>
              {invoices.map((invoice, idx) => (
                <Accordion.Item eventKey={String(idx)} key={invoice.id}>
                  <Accordion.Header>{invoice.serviceType}</Accordion.Header>
                  <Accordion.Body>
                    <p style={styles.textNormal}>
                      Đơn giá: {formatMoney(invoice.total)} VND
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
            <div style={{ display: "inline-block", marginTop: 16 }}>
              <h5>
                <b>Thành tiền: </b>
                {formatMoney(
                  invoices
                    .map((o) => o.total)
                    .reduce((prv, current) => prv + current, 0)
                )}{" "}
                VND
              </h5>
            </div>
          </Card>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {data?.paymentStatus !== "PAID" ? (
          <Button
            variant="primary"
            onClick={() => {
              if (data?.id) {
                handlePayment(data?.id);
              }
            }}
          >
            Thanh toán
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={() => {
              if (data?.id) {
                handleUnPayment(data?.id);
              }
            }}
          >
            Chưa thanh toán
          </Button>
        )}
        <Button variant="secondary" onClick={() => handleClose()}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ContractDetailComponent;
